import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(
    public db: AngularFireDatabase,
  ) { }

  get(userId) {
    const items = this.db.object(`users/${userId}`).valueChanges();
    return items;
  }

  add(value, userData) {
    const orderIdf = this.db.createPushId();
    let nodeUri: string;
    if (userData.type === 'admin') {
      nodeUri = 'orders/accepts';
      value.type = 'accept';
    } else {
      nodeUri = 'orders/requests';
      value.type = 'request';
    }
    value.auth = userData;
    value.orderId = orderIdf;
    value.timeCreated = new Date().getTime();

    return this.db.object(`${nodeUri}/${orderIdf}`).set(value);
    // return this.db.list(`orders`).push(value);
  }
}
